/**
 * @see https://gist.github.com/gajus/0bbc78135d88a02c18366f12237011a5
 *
 * @param history {@see https://www.npmjs.com/package/history}
 * @param timeout A number of milliseconds to wait for the element to appear after PUSH action has been received.
 */
export default ( history, timeout = 2000 ) => {
	let observer
	let timeoutId

	if ( ! window.MutationObserver ) {
		return
	}

	const reset = () => {
		if ( timeoutId ) {
			clearTimeout( timeoutId )

			timeoutId = null
		}

		if ( observer ) {
			observer.disconnect()
		}
	}

	const createScrollToElement = ( id ) => {
		return () => {
			const element = document.getElementById( id )

			if ( element ) {
				element.scrollIntoView()
				element.classList.add( 'is-target' )

				reset()

				return true
			}

			return false
		}
	}

	function scroll( location ) {
		if ( typeof location.hash !== 'string' ) {
			return
		}

		const elementId = location.hash.slice( 1 )

		if ( ! elementId ) {
			return
		}

		const scrollToElement = createScrollToElement( elementId )

		setTimeout( () => {
			if ( scrollToElement() ) {
				return
			}

			observer = new MutationObserver( scrollToElement )

			observer.observe( document, {
				attributes: true,
				childList: true,
				subtree: true,
			} )

			timeoutId = setTimeout( reset, timeout )
		} )
	}

	const isTabInBackground = () => {
		return document.hidden || document.visibilityState !== 'visible'
	}

	history.listen( ( location, action ) => {
		if ( timeoutId ) {
			reset()
		}

		if ( action !== 'PUSH' || isTabInBackground() ) {
			return
		}

		scroll( location )
	} )

	// Handle initial scroll when the tab becomes visible:
	document.addEventListener( 'visibilitychange', () => {
		if ( ! isTabInBackground() ) {
			requestAnimationFrame( () => {
				scroll( location )
			} )
		}
	} )

	// Initial scroll when the page loads:
	requestAnimationFrame( () => {
		scroll( location )
	} )
}



// WEBPACK FOOTER //
// ./utilities/createHistoryHashObserver.jsx